import {DropdownProps} from 'components/Dropdown';

/**
 * The action types.
 * @param {'submit'} Submit
 * @param {'reset'} Reset
 */
export enum ActionType {
  Submit = 'submit',
  Reset = 'reset',
}

/**
 * The interface of the action button.
 * @param {ActionType} type
 * @param {JSX.Element | JSX.Element[]} children
 */
export interface ActionButton {

  /**
   * Type of the button.
   * @type {ActionType}
   */
  type: ActionType;

  /**
   * Children content.
   * @type {JSX.Element | JSX.Element[]}
   */
  children:
    | JSX.Element
    | JSX.Element[];

}

/**
 * The props interface of a action sheet component.
 * @param {string} title
 * @param {ActionButton[] | undefined} actions
 */
export type ActionSheetProps =
  Pick<DropdownProps,
    | 'trigger'
    | 'side'
    | 'align'
    | 'children'> & {

  /**
   * Title of the sheet.
   * @type {string}
   */
  title: string;

  /**
   * The actions of the sheet.
   * @type {ActionButton[] | undefined}
   */
  actions?: ActionButton[];

};
